export const CONVERSATIONS_LOADER = "CONVERSATIONS_LOADER";
export const MESSAGES_LOADER = "MESSAGES_LOADER";
export const DASHBOARD_LOADER = "DASHBOARD_LOADER";